/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";

// Redux Store
import { each, get, isEmpty } from "lodash";
import { ModalHeader } from "../Modal";

import { COMPANY_STATE } from "../../constants/COMPANY";
import Companies from "./Companies";
import Form from "../Form";
import { comma } from "../../utils/number";
import ToolTip from "../ToolTip/ToolTip";
import { companyApproved, companyPause, updatePartner } from "../../apis/admin/companies";
import systemAlert from "../../utils/systemAlert";
import { transformComNum } from "../../utils/validator/comNum";


const PartnerCompany = ({ company, setCompany }) => {
  const [fields] = useState([
    [
      {
        title: "상호", label: "-", key: "name"
      },
      { title: "사업자번호", label: "-", key: "comNum", onValue: (v) => transformComNum(v) }
    ],
    [
      {
        title: "대표자명",
        label: "-",
        key: "ceoName",
        onValue: (value, fileds, data) => {
          const ceos = data.employees.filter(
            (e) => get(e, "companyRoleEmployees[0].companyRole.type", null) === 1
          );
          return (
            <>
              {value}
              {!isEmpty(ceos) && (
                <ToolTip
                  tooltiptext={ceos
                    .map(
                      (c) => `${c.name}(${c.userId}) / ${c.mobile} / ${c.email}`
                    )
                    .join("\n\n")}
                  position="bottom"
                ></ToolTip>
              )}
            </>
          );
        },
      },
      {
        title: "직원수",
        label: "-",
        key: "employees",
        onValue: (value, field, data) => {
          return (
            <>
              {comma(value.length)} 명
            </>
          );
        },
      },
    ],
    [
      {
        title: "타입",
        label: "-",
        key: "type",
        onValue: (val, fields, form) => {
          let type = "기업";
          switch (val) {
            case 2:
              type = "세무사";
              break;
            case 3:
              type = "노무사";
              break;
            case 9:
              type = "경리대행";
              break;

            default:
              break;
          }
          return type;
        },
      },
      {
        title: "코드",
        label: "-",
        key: "code"
      },
    ],
    [

      {
        title: "승인 상태",
        label: "-",
        key: "state",
        onTranslator: { list: COMPANY_STATE },
      },
      {
        title: "승인상태 변경",
        type: "button",
        size: "x-sm",
        color: "gray-line",
        onValue: (value, _fields, data) => {
          return <>{data.state === 1 ? "일시중지" : "승인"}하기</>;
        },
        onClick: ({ data }) => {
          systemAlert(`${data.name} ${data.state === 1 ? "일시중지" : "승인"}하시겠습니까?`, {
            buttons: [
              {
                color: 'text',
                label: '취소'
              },
              {
                label: '확인',
                onClick: () => {
                  if (data.state === 1) {
                    companyPause(data.idx).then(() => {
                      setCompany({
                        ...company,
                        state: 2
                      });
                    });
                  } else {
                    companyApproved(data.idx).then(() => {
                      setCompany({
                        ...company,
                        state: 1
                      });
                    });
                  }
                }
              }
            ]
          });

        },
      },


    ],
    [
      {
        title: "회사 타입",
        label: "-",
        key: "isPartner",
        onTranslator: { list: [{ label: "일반", value: false }, { label: "파트너", value: true }] },
      },
      {
        title: "회사 타입 변경",
        type: "button",
        size: "x-sm",
        color: "gray-line",
        key: "isPartner",
        onValue: (value, _fields) => {
          return <>{value ? "파트너 해지" : "파트너 가입"}하기</>;
        },
        onClick: ({ data }) => {
          systemAlert(`${data.name} ${data.isPartner ? "파트너 해지" : "파트너 가입"}하시겠습니까?`, {
            buttons: [
              {
                color: 'text',
                label: '취소'
              },
              {
                label: '확인',
                onClick: () => {
                  updatePartner({ companyIdx: data.idx, isPartner: !data.isPartner });
                  setCompany({
                    ...company,
                    isPartner: !data.isPartner
                  });
                }
              }
            ]
          });

        },
      },
    ]
  ]);

  const setCareCompany = useCallback((careCompany) => {
    company.careCompanies.forEach((data) => {
      if (data.idx === careCompany.idx) {
        each(data, (v, k) => {
          data[k] = careCompany[k];
        });
      }
    });
    setCompany(company);
  }, []);

  return (
    <>
      <ModalHeader size="md">기본정보</ModalHeader>
      <div className="partner-company-info">
        <Form isRequiredShow={true} fields={fields} mode="view" form={company} />
      </div>
      <ModalHeader size="md">고객사</ModalHeader>
      <Companies companyList={company.careCompanies} setCareCompany={setCareCompany}></Companies>
    </>
  );
};

export default PartnerCompany;
